export default __webpack_public_path__ + "static/media/NobelWGL-Book.fa7bc303.ttf";